import { FieldError } from 'react-hook-form';

/**
 * Checks that a case number is digits, a dot, a four-digit year, a dot and two uppercase letters.
 * Example: `123.2024.AB` is valid.
 */
export function isCaseNumberValid(caseNumber: string): boolean {
  const pattern: RegExp = /^\d+\.\d{4}\.[A-Z]{2}$/;
  return pattern.test(caseNumber);
}

export function getCaseNumberErrorMessage(error: FieldError) {
  if (error.type === 'required') {
    return 'Die Fallnummer muss ausgefüllt werden';
  }
  if (error.type === 'format') {
    return 'Format der Fallnummer inkorrekt';
  }
  return 'Fallnummer wurde bereits einem anderen Patienten zugewiesen';
}
